module.exports = __webpack_public_path__ + "img/play-store.ffc170d8.jpg";